<template>
  <div class="beneficios">
    <div class="row">
      <public-header :title="'Benefícios Assistenciais'">
        <ano-base />
        <div class="col-xs-12">
          <p>&nbsp;</p>
        </div>
        <div class="col-xs-12 col-sm-6">
          <p>
            A
            <span class="destaque-header">Prefeitura Municipal de Santos</span>,
            através da
            <span class="destaque-header"
              >Secretaria de Desenvolvimento Social</span
            >, no ano de <span class="destaque-header">{{ ano_base }}</span
            >, repassou um valor total de
            <span class="destaque-header">{{
              formatarMoeda(totalAno.valor)
            }}</span>
            em benefícios assistenciais para a sua população.
          </p>
          <p>
            Cerca de
            <span class="destaque-header">{{
              totalAno.total.toLocaleString()
            }}</span>
            pagamentos de benefícios foram repassados através dos diversos
            programas Municipais, Estaduais e Federais, entre eles o
            <span class="destaque-header">
              Programa Nossa Família - PNF ({{ pnf.total.toLocaleString() }}
              benefícios, totalizando
              {{ formatarMoeda(Number(pnf.valor)) }})</span
            >, o
            <span class="destaque-header"
              >Programa Ação Jovem ({{ acao_jovem.total.toLocaleString() }}
              benefícios, totalizando
              {{ formatarMoeda(Number(acao_jovem.valor)) }})</span
            >
            e o
            <span class="destaque-header"
              >Programa de Transferência de Renda - Auxílio Brasil ({{
                bolsa_familia.total.toLocaleString()
              }}
              benefícios, totalizando
              {{ formatarMoeda(Number(bolsa_familia.valor)) }})</span
            >.
          </p>
          <h3>Secretaria de Desenvolvimento Social</h3>
          <p>
            <span class="destaque-header">
              Tel.: <a href="tel:+551332131499">(13) 3213-1499</a><br />
              Email:
              <a href="mailto:seds@santos.sp.gov.br">seds@santos.sp.gov.br</a>
            </span>
          </p>
        </div>
        <div class="col-xs-12 col-sm-6">
          <bar-chart
            ref="beneficios_mensais"
            :chart-data="graficoHeader"
            :gradiente="false"
            :coloredLine="true"
            :options="{
              responsive: true,
              maintainAspectRatio: false,
              title: {
                display: true,
                text: 'Benefícios Mensais',
                fontColor: '#C1D1C1'
              },
              legend: {
                display: true,
                labels: {
                  fontColor: '#C1D1C1'
                }
              },
              dataset: {
                maxBarThickness: 50
              },
              scales: {
                yAxes: [
                  {
                    ticks: {
                      beginAtZero: true,
                      suggestedMax: 50,
                      fontColor: '#C1D1C1',
                      callback: function(value, index, values) {
                        return value.toLocaleString('pt-br', {
                          style: 'currency',
                          currency: 'BRL'
                        })
                      }
                    }
                  }
                ],
                xAxes: [
                  {
                    ticks: {
                      fontColor: '#C1D1C1'
                    }
                  }
                ]
              },
              tooltips: {
                callbacks: {
                  label: function(tooltip, dataset) {
                    var yLabel = tooltip.yLabel.toLocaleString('pt-br', {
                      style: 'currency',
                      currency: 'BRL'
                    })
                    return 'Valor: ' + yLabel
                  }
                }
              }
            }"
          ></bar-chart>
        </div>
      </public-header>
    </div>
    <div class="container">
      <div class="row">
        <ol class="breadcrumb">
          <li><router-link :to="'/'">Início</router-link></li>
          <li class="">Benefícios Assistenciais</li>
        </ol>
      </div>
      <div class="row">
        <div class="col-xs-12">
          <h3>Saiba mais sobre os benefícios</h3>
        </div>
      </div>
      <transition-group name="fade" tag="div" class="row" v-if="!carregando">
        <div
          v-for="item in beneficios"
          :key="item.codigo"
          class="col-xs-12 col-sm-6 col-md-4"
        >
          <card-lg
            :title="item.sigla"
            :description="item.nome"
            :url="{
              name: 'beneficios_detalhes',
              params: {
                sigla: item.sigla,
                item
              }
            }"
          />
        </div>
      </transition-group>
    </div>
  </div>
</template>

<script>
import {
  BarChart,
  PublicHeader,
  CardLG as CardLg,
  AnoBase
} from '../../../components/common/'

import { formatarMoeda, mesesAbr } from '../../../utils/strings'
import { request } from '../../../request'
import { mapState } from 'vuex'
import colors from '../../../utils/colors'

export default {
  components: { PublicHeader, BarChart, CardLg, AnoBase },
  data() {
    return {
      carregando: true,
      grafico_base: { labels: [], datasets: [{ label: '', data: [] }] },
      total_ano: [],
      total_mes: [],
      beneficios: []
    }
  },
  mounted() {
    const ano = this.ano_base

    request
      .get('/assistencia/listar-beneficios')
      .then(response => {
        const { data } = response
        this.beneficios = [...data]
      })
      .catch(error => {
        const { data } = error.response
        this.$toastr.e(
          'Houve um erro ao carregar a lista de benefícios. Atualize a página e, caso o problema persista, contate o administrador.'
        )
        console.log(data.msg)
      })

    this.retornarPagamentosAno(ano)
    this.retornarPagamentosMes(ano)
  },
  methods: {
    formatarMoeda,
    retornarPorSigla(sigla) {
      const filter = item => {
        return item.beneficio === sigla
      }

      const result = this.total_ano.filter(filter)

      if (result.length) {
        return _.first(result)
      }

      return { total: 0, valor: 0 }
    },
    retornarPagamentosAno(ano) {
      request
        .get('/assistencia/pagamentos-ano/' + ano)
        .then(response => {
          const { data } = response
          this.total_ano = [...data]
        })
        .catch(error => {
          const { data } = error.response
          this.$toastr.e(
            'Houve um erro ao carregar os totais por ano. Atualize a página e, caso o problema persista, contate o administrador no email do rodapé.'
          )
          console.log(data.msg)
        })
        .then(() => {
          this.carregando = false
        })
    },
    retornarPagamentosMes(ano) {
      request
        .get('/assistencia/pagamentos-mes/' + ano)
        .then(response => {
          const { data } = response
          this.total_mes = [...data]
        })
        .catch(error => {
          const { data } = error.response
          this.$toastr.e(
            'Houve um erro ao carregar os totais por mês. Atualize a página e, caso o problema persista, contate o administrador no email do rodapé.'
          )
          console.log(data.msg)
        })
        .then(() => {
          this.carregando = false
        })
    }
  },
  watch: {
    ano_base: function(newValue /*, oldValue*/) {
      this.retornarPagamentosAno(newValue)
      this.retornarPagamentosMes(newValue)
    }
  },
  computed: {
    ...mapState({
      ano_base: state => state.receitas_despesas.ano_base
    }),
    pnf() {
      return this.retornarPorSigla('PNF')
    },
    acao_jovem() {
      return this.retornarPorSigla('ACAO JOVEM')
    },
    bolsa_familia() {
      return this.retornarPorSigla('AUXILIO BRASIL')
    },
    graficoHeader() {
      const labels = [...mesesAbr]
      const data = Array(12).fill(0)

      this.total_mes.forEach(element => {
        data[element.mes - 1] = element.valor
      })

      const datasets = [
        {
          label: this.ano_base,
          data,
          backgroundColor: colors.coresHexa[0]
        }
      ]

      return {
        ...this.grafico_base,
        labels,
        datasets
      }
    },
    totalAno() {
      const reducer = (acum, atual) => {
        acum.valor += Number(atual.valor)
        acum.total += Number(atual.total)
        return acum
      }

      return this.total_ano.reduce(reducer, { valor: 0, total: 0 })
    }
  }
}
</script>

<style></style>



// WEBPACK FOOTER //
// src/views/public/assistencia/index.vue